import {
  Box,
  Grid,
} from "@material-ui/core";
import React from "react";
import useStyles from "../../../../themes/style.js";

const KYCDetails = ({ userDetails, onUpdate }) => {
  const classes = useStyles();

  return (
    <div>
      <Box>
        <div className="emp-profile-details-table-card">
          <h3 className="gradienttext">KYC Details</h3>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <table className="emp-profile-details-table">
                <tbody>
                  <tr>
                    <td>Aadhaar Number</td>
                    <td>
                      {userDetails.salary_detail?.aadhaarNumber || (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>PAN Number</td>
                    <td>
                      {userDetails.salary_detail?.panNumber || (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>UAN Number</td>
                    <td>
                      {userDetails.salary_detail?.uanNumber ? (
                        userDetails.salary_detail?.uanNumber
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>ESI Number</td>
                    <td>
                      {userDetails.salary_detail?.esiNumber || (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <table className="emp-profile-details-table">
                <tbody>
                  <tr>
                    <td>PF Number</td>
                    <td>
                      {userDetails.salary_detail?.pfNumber || (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Bank Name</td>
                    <td>
                      {userDetails.salary_detail?.bankName ? (
                        userDetails.salary_detail?.bankName
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Bank Account Number</td>
                    <td>
                      {userDetails.salary_detail?.bankAccountNumber ? (
                        userDetails.salary_detail?.bankAccountNumber
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Bank IFSC Code</td>
                    <td>
                      {userDetails.salary_detail?.bankIfscCode ? (
                        userDetails.salary_detail?.bankIfscCode
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>
          </Grid>
        </div>
      </Box>
    </div>
  );
};

export default KYCDetails;
